import { FormEvent } from "react";
import useListRowInfStroe from "store/listRowInf";
import {
  initialFilterStateProps,
  useResvCancelFilterContext,
  useResvCancelParamContext,
} from "./context";

export const useSubmit = () => {
  const { setParam } = useResvCancelParamContext();
  const { filters } = useResvCancelFilterContext();
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let param = {} as Partial<initialFilterStateProps>;
    filters &&
      (Object.keys(filters) as Array<keyof initialFilterStateProps>).forEach(
        (key) => {
          let value = filters[key];
          if (key === "dateTyp") {
            param = {
              ...param,
              [(value || "sell") + "SDt"]: filters.sDt,
              [(value || "sell") + "Edt"]: filters.eDt,
            };
            return;
          }
          if (key === "sDt" || key === "eDt") {
            return;
          }
          if (!!value) {
            param = {
              ...param,
              [key]: value,
            };
          }
        }
      );

    setParam(param);
  };

  return {
    onSubmit,
  };
};

// 상세

export const detail = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;
  const params = {
    no: props.data.rmNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
    param: {
      rmPdNo: props.data.rmPdNo,
      rmResvNo: props.data.rmResvNo,
    },
  };
  setListRowParams(params);
};
